module.exports = __webpack_public_path__ + "assets/ff4071584f2994a95519021160330e89.png";